

















import { Component, Vue, Prop } from 'vue-property-decorator';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class GenerateContractDialog extends Vue {
    @Prop({ required: true })
    private contractId!: string;

    private contractTemplates: IMachineryTemplate[] = [];
    private showValue: boolean = false;
    private saving: boolean = false;
    private contractGenerationModel: IMachineryGenerateContractCommand = {
        id: '',
        template: '',
    };

    public show() {
        this.showValue = true;
    }

    public hide() {
        this.showValue = false;
    }

    public async created() {
        try {
            this.contractTemplates = (await machineryRentalsRepository.getTemplates()).data;
        } catch (err) {
            notificationService.showAxiosError(err);
        }
    }

    private async save() {
        try {
            const validationResult = (this.$refs.GenerateContractForm as any).instance.validate();
            if (validationResult.isValid) {
                this.saving = true;
                // Create
                this.contractGenerationModel.id = this.contractId;
                await machineryRentalsRepository.generateContract(this.contractGenerationModel);
                notificationService.saved();
                this.hide();
                this.$emit('saved');
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    get generateContractFields() {
    const self = this;
    return [
      {
        itemType: 'simple',
        dataField: 'template',
        editorOptions: {
          items: self.contractTemplates,
          valueExpr: 'name',
          displayExpr: 'name',
          searchEnabled: true,
        },
        editorType: 'dxLookup',
        label: {
          text: 'Template',
        },
        validationRules: [
          {type: 'required', message: 'Veld is verplicht'},
        ],
      },
    ];
  }
}
